import React from 'react';
import { TrendingUpIcon, ShoppingBagIcon, CalendarIcon } from 'lucide-react';
export function Hero() {
  return <section className="relative overflow-hidden bg-gradient-to-br from-green-500 to-emerald-600 text-white" data-id="element-67">
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiNmZmZmZmYiIGZpbGwtb3BhY2l0eT0iMC4xIj48cGF0aCBkPSJNMzYgMzRjMC0yLjIxLTEuNzktNC00LTRzLTQgMS43OS00IDQgMS43OSA0IDQgNCA0LTEuNzkgNC00em0wLTEwYzAtMi4yMS0xLjc5LTQtNC00cy00IDEuNzktNCA0IDEuNzkgNCA0IDQgNC0xLjc5IDQtNHptMC0xMGMwLTIuMjEtMS43OS00LTQtNHMtNCAxLjc5LTQgNCAxLjc5IDQgNCA0IDQtMS43OSA0LTR6Ii8+PC9nPjwvZz48L3N2Zz4=')] opacity-20" data-id="element-68"></div>

      <div className="relative max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28" data-id="element-69">
        <div className="text-center" data-id="element-70">
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-71">
            <ShoppingBagIcon className="w-12 h-12" data-id="element-72" />
            <h1 className="text-5xl sm:text-6xl font-bold" data-id="element-73">Lola</h1>
          </div>

          <h2 className="text-3xl sm:text-5xl font-bold mb-6 leading-tight" data-id="element-74">
            Turn Everyday Purchases Into Health Outcomes
          </h2>

          <p className="text-xl sm:text-2xl mb-10 text-green-50 max-w-3xl mx-auto" data-id="element-75">
            Lola helps Food-as-Medicine platforms make healthier eating
            effortless—by suggesting food swaps people will actually buy
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-76">
            <button className="bg-white text-green-600 px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all flex items-center gap-2" data-id="element-77">
              <CalendarIcon className="w-5 h-5" data-id="element-78" />
              Book a Partner Demo
            </button>
            <button className="bg-orange-500 text-white px-8 py-4 rounded-full font-semibold text-lg shadow-lg hover:shadow-xl hover:scale-105 transition-all flex items-center gap-2" data-id="element-79">
              <TrendingUpIcon className="w-5 h-5" data-id="element-80" />
              See How It Works
            </button>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0" data-id="element-81">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-82">
          <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="white" data-id="element-83" />
        </svg>
      </div>
    </section>;
}